import React, { useState } from 'react';
import { useController } from './controller';
import { useParticles } from './particles';
import * as S from './styles';
import DefaultLoading from '../../components/DefaultLoading';
import { translations, LanguageKeys } from './translation';

const Login = (props: any) => {
    const controller = useController();

    return (
        <S.mainContainer>
            <DefaultLoading active={controller.loading} />
            <S.loginContainer>
                <S.loginForm onSubmit={e => controller.login(e)}>
                    <S.loginTitleImage src={`./images/Logo_and_name_transparent_bg_var.png`} alt="Logo" />
                    <S.loginInput autoComplete={'off'} onChange={controller.handleChange} name='email' type='email' placeholder="Email" />
                    <S.loginInput autoComplete={'off'} onChange={controller.handleChange} name='password' type='password' placeholder={translations[controller.currentLanguage].password} />
                    <S.loginButton>{translations[controller.currentLanguage].login}</S.loginButton>
                    <S.linksContainer>
                        <S.loginLink onClick={() => controller.general.GoToRoute('/register')}>{translations[controller.currentLanguage].signup}</S.loginLink>
                        <S.loginLink onClick={() => { controller.general.toast.info(translations[controller.currentLanguage].stillDeveloping) }}>{translations[controller.currentLanguage].forgotPassword}</S.loginLink>
                    </S.linksContainer>
                </S.loginForm>
            </S.loginContainer>
        </S.mainContainer>
    )
}

const MountedComponent = (props: any) => {
    const particles = useParticles();

    return (
        <>
            <Login />
            <S.particles
                id="tsparticles"
                particlesLoaded={particles.particlesLoaded as any}
                options={particles.options}
            />
        </>
    )
}

export default MountedComponent;